import numeral from 'numeral'
import { ReactNode } from 'react'

import { Heading4 } from '../Typography'

type UploadProgressProps = {
  title?: string
  content?: ReactNode
  isUploading: boolean
  percentageComplete: number
  filesComplete: number
  filesCount: number
}

const UploadProgress = ({
  title,
  content,
  isUploading,
  percentageComplete,
  filesComplete,
  filesCount
}: UploadProgressProps) => {
  if (isUploading) {
    return (
      <div className='modal-overlay z-20 bg-black/60 fixed top-0 bottom-0 left-0 right-0 flex flex-col items-center justify-center'>
        <div className='m-2 rounded-md text-shark bg-linen w-full max-w-[420px] p-4 flex flex-col gap-2'>
          <Heading4 className='m-0!'>{title || 'Saving your changes'}</Heading4>
          <div>{content}</div>
          <span>
            Uploading your files ({filesComplete} of {filesCount} complete)
          </span>
          <div className='relative overflow-clip bg-linen text-white font-bold w-full border border-shark rounded-xs'>
            <div
              className='flex flex-col items-center justify-center bg-secondary h-[20px]'
              style={{
                width: `${percentageComplete}%`
              }}
            >
              <span className='font-bold text-shark -translate-x-1/2 -translate-y-1/2 top-1/2 left-1/2 absolute'>
                {numeral(percentageComplete).format('0')}%
              </span>
            </div>
          </div>
        </div>
      </div>
    )
  }

  return null
}

export default UploadProgress
